import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface HandleResult {
  missingUris: string[]
  checkedAt: number
}

interface State {
  results: Record<string, HandleResult>
  setResult: (handle: string, missing: string[], checkedAt: number) => void
  getResult: (handle: string) => HandleResult | null
  clear: (handle: string) => void
}

export const useProfileDeletion = create<State>()(
  persist(
    (set, get) => ({
      results: {},

      setResult: (handle, missing, checkedAt) =>
        set((s) => ({
          results: { ...s.results, [handle]: { missingUris: missing, checkedAt } },
        })),

      getResult: (handle) => get().results[handle] ?? null,

      clear: (handle) =>
        set((s) => {
          const next = { ...s.results }
          delete next[handle]
          return { results: next }
        }),
    }),
    {
      name: 'bskyhq:profile-deletion',
    },
  ),
)
